<template>
	<el-container class="advanced-keyword">
		<el-header height="40px" v-show="step == 'list'">
			<el-row :gutter="20">
				<el-col :span="14">
					<el-input placeholder="搜索关键词 / 规则名称" v-model="searchVal" clearable
						prefix-icon="el-icon-search" size="mini"></el-input>
				</el-col>
				<el-col :span="10">
					<el-button class="search-btn" size="mini" @click="onSearch">查 询</el-button>
					<el-button type="primary" size="mini" @click="onReset">重 置</el-button>
					<el-button type="primary" size="mini" plain icon="el-icon-plus" @click="onDetail()">添 加</el-button>
				</el-col>
			</el-row>
		</el-header>
		<el-main>
			<template v-if="step == 'list'">
				<table-pagination v-loading="loading" ref="tableItem" pagination layout="prev,pager,next,total" :data="list"
					:column="column" :total="total" :page.sync="listQuery.pageNum" :limit.sync="listQuery.pageSize"
					@pagination="getList">
					<template v-slot:expand="{row}">
						<ul class="expand-lists">
							<li>
								<span>关键词：</span>
								<el-tag size="mini" v-for="(keyword,index) in row.rulesKeyList" :key="index">{{keyword.keysValue}}</el-tag>
							</li>
							<li>
								<span>回复内容：</span>
								<el-tag size="mini" v-for="(response,index) in row.rulesResponseList" :key="index" :type="response.responseType == 'text' ? '' : 'danger'">
									{{response.responseType == 'text' ? '文本': 'IM'}} : {{response.response}}
								</el-tag>
							</li>
						</ul>
					</template>
					<template v-slot:action="{row}">
						<div class="operate-inline">
							<el-button type="text" size="small" @click="onDetail(row)">编辑</el-button>
							<el-divider direction="vertical"></el-divider>
							<el-popconfirm title="确定要删除规则吗？" icon="el-icon-info" @confirm="onDelete(row)">
							   <el-button slot="reference" type="text" size="small">删除</el-button>
							</el-popconfirm>
						</div>
					</template>
				</table-pagination>
			</template>
			<template v-else>
				<DetailView :detailViewer="detailViewer" @onCancel="onCancel" @onSubmit="onSubmit"/>
			</template>
		</el-main>
	</el-container>
</template>

<script>
	import DetailView from './detail';
	export default {
		components:{
			DetailView
		},
		props:{
			source:{
				default:''
			}
		},
		watch:{
			'source':{
				handler(value){
					if(value){
						this.getList();
					}
				},
				immediate:true,
				deep:true
			}
		},
		data(){
			return{
				listQuery: {
					pageNum: 1,
					pageSize: 10
				},
				searchVal:'',
				loading:false,
				total:0,
				list:[],
				column:[
					{
							label: '更多',
							prop: 'expand',
							type: 'expand',
							slotScope: true
						},
						{
							label: '规则名称',
							prop: 'rulename',
						},
						{
							label: '关键词',
							prop: 'rulesKeyList',
							render:(h,scope)=> {
								return <span>{this.formatValue(scope.row.rulesKeyList,'keysValue')}</span>
							}
							
						},
						{
							label: '回复内容',
							prop: 'rulesResponseList',
							render:(h,scope)=> {
								return <span>{this.formatValue(scope.row.rulesResponseList,'response')}</span>
							}
						},
						{
							label: "操作",
							prop: "action",
							align: "center",
							width: 120,
							fixed:'right',
							slotScope: true,
						}
				],
				step:'list',
				detailViewer:{
					source:null,
					parentSource:null
				}
				
				
			}
		},
		methods:{
			onSearch(){
				this.listQuery.pageNum = 1;
				this.getList();
			},
			getList(){
				this.step = 'list';
				this.$api.getWeiboKeywordListForSystem({
					data: {
					   appid: this.source.weiboId,
					   searchvalue: this.searchVal
					 },
					 pageNum: this.listQuery.pageNum,
					 pageSize: this.listQuery.pageSize,
				}).then(res => {
					if(res.errcode != 0) return;
					this.list = res.list;
					this.total = res.total;
				})
			},
			onSubmit(){
				this.listQuery.pageNum = 1;
				this.getList();
			},
			formatValue(data,key){
				let results = [];
				if(data){
					data.map(item => {
						results.push(item[key])
					})
				}
				return results.join(',')
			},
			// 添加,编辑关键字回复
			onDetail(row){
				this.step = 'operate';
				this.detailViewer = {
					source:row || null,
					parentSource:this.source
				}
			},
			onReset(){
				this.searchVal = '';
				this.onSearch();
			},
			onDelete(row){
				this.$api.deleteWeiboKeywordForSystem({id:row.id}).then(res => {
					if(res.errcode != 0) return;
					this.$notify.success('删除成功');
					this.getList();
				})
			},
			onCancel(){
				this.step = 'list';
			}
		}
	}
</script>

<style lang="scss" scoped>
	.advanced-keyword {
		.expand-lists {
			width: 100%;
			li {
				list-style: none;
				font-size: 12px;
				margin: 5px 0;
				width: 100%;
				
				>span {
					font-weight: bold;
					margin: 3px;
				}
			}
		}
	}
	
</style>